import { FormEvent, useRef, useState } from 'react';
import styles from '@/components/auth/login.module.css';
import { useRouter } from 'next/router';
import Link from 'next/link';
import { signIn } from 'next-auth/react';

function Login() {
  const router = useRouter();
  const emailInputRef = useRef<HTMLInputElement>(null);
  const passwordInputRef = useRef<HTMLInputElement>(null);
  const [errorMessage, setErrorMessage] = useState('');

  async function submitHandler(event: FormEvent) {
    event.preventDefault();
    const enteredEmail = emailInputRef.current!.value;
    const enteredPassword = passwordInputRef.current!.value;

    const result: any = await signIn('credentials', {
      redirect: false,
      email: enteredEmail,
      password: enteredPassword,
    });
    if (!result.error) {
      router.replace('/profile');
    } else {
      setErrorMessage(result.error);
    }
  }
  
  return (
    <>
      <div className={styles.profile}>
        <div className={styles.itemleft}>
          <h1 className="h1">Login</h1>
          <span className="material-icons">account_circle</span>
        </div>
      </div>
      <form className="form" onSubmit={submitHandler}>
        <div className="login-input-container">
          <input
            autoComplete="off"
            className="login-input"
            type="email"
            id="email"
            ref={emailInputRef}
            placeholder="Email Address"
          />
        </div>
        <div className="login-input-container">
          <input
            autoComplete="off"
            className="login-input"
            type="password"
            id="password"
            ref={passwordInputRef}
            placeholder="Password"
          />
        </div>
        <div id="error" className={styles.errorMessage}>
          {errorMessage}
          {errorMessage !== '' ? (
            <span className="material-icons" style={{ marginLeft: '0.5rem' }}>
              error
            </span>
          ) : null}
        </div>
        <Link href="/signup" passHref>
          <div className="cursor align-center no-select underline">
            Create Account
          </div>
        </Link>
        <div className="buttons no-select">
          <button className="button">Login</button>
        </div>
      </form>
    </>
  );
}

export default Login;
